const mutualLove = {
  state: {
    mutualLove: {},
    mutualLoveJS: {},
    mutualLovenum: {}
  },
  mutations: {
    SET_mutualLove (state, mutualLove) {
      state.mutualLove = mutualLove
    },
    SET_mutualLoveJS (state, mutualLoveJS) {
      state.mutualLoveJS = mutualLoveJS
    }
  }
}

export default mutualLove



// WEBPACK FOOTER //
// ./src/store/modules/mutualLove.js